const getters = {
  getChildData: state => state.report.getChildData,
  checkList: state => state.report.checkList,
}
export default getters
